// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	INPUT: 'input[type=search]',
	SEARCH: 'button',
};

export default class SearchForm extends WebComponent {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	didMount() {
		const {
		} = this.props;

		this.inputElement = this.element.querySelector(fragments.INPUT);
		this.searchElement = this.element.querySelector(fragments.SEARCH);
		this.inputElement.addEventListener('keydown', this.handleSubmit);
		this.inputElement.addEventListener('keyup', this.treatmentSearchEl);

	}

	handleSubmit = (e) => {
		let key = e.which || e.keyCode;
		switch(key) {
			case 13:
				e.preventDefault();
				this.searchElement.click();
				break;
			default:
		}
	}

	treatmentSearchEl = (e) => {
		if(e.target.value.length > 0) {
			let numsRgx = e.target.value.match(/(\d+)/g);
			if(numsRgx){
				if (numsRgx.join([]).length > 4) {
					this.inputElement.value = e.target.value.replace(' ','');
				}
			}
		}
	}

	cancelFormData = () => {
		this.inputElement.value = '';
		this.searchElement.click();
	}
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SearchForm.js